// src/components/SEO.jsx
import React from "react";
import { useLocation } from "react-router-dom";

export default function SEO({
  title = "MusicBase",
  description = "MusicBase – Playlist outreach built for artists.",
  canonical = null,         // if null → auto-canonical
  image = "https://www.musicbase.io/logo.png",
  robots = "index, follow",
  jsonLd = null,
  ogType = "website",
  twitterCard = "summary_large_image"
}) {
  const location = useLocation();

  // 🔥 UPDATED BASE URL
  const BASE_URL = "https://www.musicbase.io";

  // Auto-canonical always uses pathname
  const autoCanonical = BASE_URL + location.pathname;

  // Include search params (for OG)
  const fullUrl = BASE_URL + location.pathname + location.search;

  return (
    <>
      {/* Primary SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical || autoCanonical} />
      <meta name="robots" content={robots} />

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="MusicBase" />

      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </>
  );
}
